export const setOrderField = (orderField) => {
  if (orderField === "campaign") orderField = "campaign__title";
  if (orderField === "tags") orderField = "tags__name";
  if (orderField === "status") orderField = "status__name";
  return orderField;
};
